import { useSelector } from "react-redux";
import "./../App.css"

const CashResult = () => {
    const cash = useSelector(state => state.cash.count);
    
    return (
        <div>
            <h2>Cash: {cash} </h2>
        </div>
    )
}


export default CashResult;